export default __webpack_public_path__ + "static/media/yellow_unlocked_lock.1ed8b4d4.svg";